import { useState } from 'react'
import AsyncSelect from './AsyncSelect'
import { useGraphQLClient } from '@utils/GraphQLClientProvider'
import type { ControllerRenderProps } from 'react-hook-form'
import { FederalDistrictsDocument } from '@frontend/graphql/queries/federalDistricts.generated'
import type { FederalDistrictsQuery, FederalDistrictsQueryVariables } from '@frontend/graphql/queries/federalDistricts.generated'
import { scopedTranslation } from '@frontend/utils/I18n'
import type { SelectOption } from '@utils/types'

type FederalDistrictSelectProps = {
  field: ControllerRenderProps<any, any>
  hideLabel?: boolean
  placeholder?: string
  isMulti?: boolean
}

const tShared = scopedTranslation('components.federal_district_select')

export default function FederalDistrictSelect({
  field,
  hideLabel = false,
  placeholder = tShared('placeholder'),
  isMulti = false
}: FederalDistrictSelectProps) {
  const [totalCount, setTotalCount] = useState<number>(0)
  const client = useGraphQLClient()

  const loadOptions = async (inputValue: string) => {
    const variables: FederalDistrictsQueryVariables = {
      nameICont: inputValue,
      first: 10,
    }

    const data = await client.request<FederalDistrictsQuery>(FederalDistrictsDocument, variables)

    setTotalCount(data.federalDistricts?.totalCount ?? 0)

    return data.federalDistricts?.nodes?.filter((district): district is SelectOption => 
      district != null && district.value != null && district.label != null
    ) ?? []
  }

  return (
    <AsyncSelect
      dataTestId="federal-district-select"
      totalCount={totalCount}
      displayName="Federal District"
      hideLabel={hideLabel}
      loadOptions={loadOptions}
      field={field}
      isMulti={isMulti}
      isCreatable={true}
      isClearable={true}
      placeholder={placeholder}
    />
  )
}